import {
  apiAddManager,
  apiDeleteManager,
  apiGetManager,
  apiGetManagers,
  apiUpdateManager,
} from "@lib/api/manager";
import { UseQueriesProps } from "@lib/types/General";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

export const useManagerQueries = (props: UseQueriesProps) => {
  const { queryKey, params, id, enabled = true, messages } = props;
  const queryKeys = queryKey || [
    "manager",
    params ? JSON.stringify(params) : id,
  ];
  const queryClient = useQueryClient();

  const managerQuery = useQuery({
    queryFn: () => apiGetManager(id, params),
    queryKey: queryKeys,
    enabled: !!id && !!enabled,
  });

  const managersQuery = useQuery({
    queryFn: () => apiGetManagers(params),
    queryKey: queryKeys,
    enabled: !!params && !!enabled,
  });

  const addManagerMutation = useMutation({
    mutationFn: apiAddManager,
    mutationKey: queryKeys,
    onSuccess() {
      toast.success(
        (messages["common.createdMessage"] as string).replace(
          "{name}",
          messages["common.manager"] as string,
        ),
      );
      queryClient.invalidateQueries({ queryKey: queryKeys });
    },
  });

  const updateManagerMutation = useMutation({
    mutationFn: apiUpdateManager,
    mutationKey: queryKeys,
    onSuccess() {
      toast.success(
        (messages["common.updatedMessage"] as string).replace(
          "{name}",
          messages["common.manager"] as string,
        ),
      );
      // queryClient.invalidateQueries({ queryKey: queryKeys });
    },
  });

  const deleteManagerMutation = useMutation({
    mutationFn: apiDeleteManager,
    mutationKey: queryKeys,
    onSuccess() {
      toast.success(
        (messages["common.deletedMessage"] as string).replace(
          "{name}",
          messages["common.manager"] as string,
        ),
      );
      queryClient.invalidateQueries({ queryKey: queryKeys });
    },
  });

  return {
    managerQuery,
    managersQuery,
    addManagerMutation,
    updateManagerMutation,
    deleteManagerMutation,
  };
};
